import React, { useEffect } from 'react'
import RoutesList from './client/Routes.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/css/style.scss'
import './new-ui/styles/style.css'
import "./new-ui/styles/index.css"

import { generateUniqueId } from './helpers/utils.js';
import { UAParser } from 'ua-parser-js';

const App = () => {

  const getOrCreateSessionId = () => {
    let sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = generateUniqueId();
      sessionStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  }

  const getOrCreateTrackerId = () => {
    let trackerId = localStorage.getItem('trackerId');
    if (!trackerId) {
      trackerId = generateUniqueId();
      localStorage.setItem('trackerId', trackerId);
    }
    return trackerId;
  }

  const collectActivityData = async () => {
    // Check if activity data already exists in local storage
    const existingData = localStorage.getItem('activityData');
    if (existingData) return;

    // Collect browser and device information 
    const parser = new UAParser();
    const browserResult = parser.getBrowser();
    const deviceResult = parser.getDevice();

    let ipAddress = 'unknown';
    let country = 'unknown';

    // Fetch IP and country information
    try {
      const response = await fetch('https://ipapi.co/json/');
      const ipData = await response.json();
      ipAddress = ipData?.ip || 'unknown';
      country = ipData?.country_name || 'unknown';
    } catch (error) {
      console.error('Error collecting IP data:', error);
    }

    let deviceType = deviceResult.type;
    if (!deviceType) {
      const os = parser.getOS().name?.toLowerCase() || '';
      if (os.includes('windows') || os.includes('mac') || os.includes('linux')) {
        deviceType = 'desktop';
      } else {
        deviceType = 'unknown';
      }
    }

    // Create activity data with fallbacks
    const activityData = {
      ipAddress,
      country,
      deviceType: deviceType,
      browserType: browserResult.name || 'unknown',
      browserVersion: browserResult.version || 'unknown',
      language: navigator.language || 'unknown'
    };

    // Save to local storage
    localStorage.setItem('activityData', JSON.stringify(activityData));
  }

  useEffect(() => {
    // Initialize session and tracker IDs
    getOrCreateSessionId();
    getOrCreateTrackerId();
    // Collect activity data
    collectActivityData();
  }, []);

  return <div id="ProjectApp" className="projectApp">
    <RoutesList />
  </div>
}

export default App